var styles = {"tabList":"styles_tab-list__zfXVx"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
